import "friendly-challenge/widget";

window.am = window.am || {};

window.am.friendlyReCaptcha = new function () {
    const that = this;

    that.init = function () {
        const captchaScript = document.getElementById('friendlyRecaptcha');

        if (captchaScript != null) {
            return;
        }

        that.waitForSolvingPuzzle();
    };

    that.waitForSolvingPuzzle = function () {
        const solutionValue = document.querySelector(".am-form .frc-captcha-solution");
        const container = $(document).find('.am-form .frc-captcha');
        const form = container.parents('form');
        const submitButton = form.find('[type="submit"]');

        if (!solutionValue || solutionValue.getAttribute("value") == ".UNSTARTED" || solutionValue.getAttribute("value") == ".UNFINISHED" || solutionValue.getAttribute("value") == ".FETCHING") {
            submitButton.prop('disabled', true);
            setTimeout(that.waitForSolvingPuzzle, 250);
        }
        else {
            submitButton.prop('disabled', false);
            const elementId = container.attr('data-captcha-element-id');
            const captcha = $(`#${elementId}`);
            captcha.val(solutionValue.getAttribute("value"));

            const onSubmit = function (e) {
                if (!$(form).valid()) {
                    console.log('form invalid')
                    return;
                }
                e.preventDefault();

                const $this = $(this);
                const submit = $this.find();            
            
                $this.off('submit', onSubmit);
                // we cannot call $(form).submit();, jquery unobtrusive validation will break. instead we are triggering the click on the submit button
                submit.click();

                return false;
            };     

            form.on('submit', onsubmit);
        }
    };
};

window.addEventListener('load', window.am.friendlyReCaptcha.init);

